import React, {Component} from "react";
import {connect} from "react-redux";
import {getObjectsThunkCreator, SETPAGETOOBJAC} from "../../redux/reducers/objectsReducer";
import './styles/objects.css'
import { LoadingOutlined} from '@ant-design/icons';
import {NewObjectsList} from "./ObjectsListP";
import AddObject from "./AddObject";
const antIcon = <LoadingOutlined style={{ fontSize: 24 }} />;

class ObjectsContainer extends Component {
    constructor(props) {
        super(props);
    }
    componentDidMount() {
        this.props.setPage(0)
    }
    state = {
        sortedInfo: null,
        searchText: '',
        searchedColumn: '',
        editing: false,
        current: {}
    };

    handleChange = (pagination, filters, sorter) => {
        console.log('Various parameters', pagination, filters, sorter);
        this.setState({
            sortedInfo: sorter,
        });
    };
    handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        this.setState({
            searchText: selectedKeys[0],
            searchedColumn: dataIndex,
        });
    };
    handleReset = clearFilters => {
        clearFilters();
        this.setState({searchText: ''});
    };

    exp = (e) => {
        this.props.setPage(1, Number(e))
    };
    edit = (e) => {
        this.setState({
            current: e,
            editing: true
        });
        console.log(e)
    }
    close = () => {
        this.setState({
            current: {},
            editing: false
        });
    }

    render() {
        if (this.props.objects && this.props.objects.length > 0) {
            this.districts = Array.from(this.props.objects, ({district}) => district);
            this.districts = Array.from(new Set( this.districts))
            this.loading = false;
        } else {
            this.loading = antIcon;
        }

        if (this.state.editing){
            return (
                <AddObject
                    close={() => {
                        this.close()
                    }}
                    post={this.props.post}
                    districts={this.districts}
                    current={this.state.current}
                    editing={this.state.editing}
                />
            )
        } else {
            return (
                <NewObjectsList
                    onChange={this.handleChange}
                    post={this.props.post}
                    districts={this.districts}
                    current={this.current}
                    editing={this.editing}
                    exp={this.exp}
                    edit={this.edit}
                />
            )
        }

    }
}


const mapStateToProps = (state) => {
    return {
        objects: state.objectsRDCR.objects,
        page: state.objectsRDCR.page
    }
};


export default connect(mapStateToProps, {
    getObjectsThunkCreator,
    SETPAGETOOBJAC
})(ObjectsContainer);


